import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select"]

  change(e) {
    this.selectTarget.form.submit()
  }
}
